import axios from 'axios';
import getHeaders from '../../constants/headers';
import { PRICElIST_BASE_URL } from '../BaseURL';

export const getChargesAndDiscount = (storeId) => {
  return axios({
    method: 'get',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/store/' +
      storeId +
      '/charge-discount', // for android use
    headers: getHeaders(),
  });
};
